import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faExternalLinkSquareAlt } from '@fortawesome/free-solid-svg-icons'
import './MainProject.css';


const MainProject = (props) => {

    const {
        projectId,
        projectName,
        projectDesc,

        projectImg,
        clientCode,
        serverCode,
        liveSite
    } = props.project;

    const { t1, t2, t3, t4, t5, t6, t7 } = props.project.technology;

    return (
        <div className="row d-flex" id="projectList">
            <div className="col-lg-6 col-md-12 col-sm-12 d-flex align-items-center mb-5" id={`order-${projectId}`}>
                <div id="projects">
                    <div className="project-image">
                        <img src={projectImg} className="img-fluid img-responsive rounded-lg" alt="" />
                    </div>
                    <div id={`projectId-${projectId}`} className="core-technologies text-left">
                        {/* <h4 className="ml-3 title-color">Core Technologies</h4>
                        <div className="technologies d-flex">
                            <small>React JS</small>
                            <small>Firebase</small>
                            <small>Express JS</small>
                            <small>Mongo DB</small>
                        </div> */}
                    </div>
                </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 mb-5">
                <div className="project-details text-right" id={`projectId-${projectId}`}>
                    <div className="project-title px-4">
                        <small className="title-color page-title">Featured Project</small>
                        <h4>{projectName}</h4>
                    </div>
                    <div className="project-description p-4 shadow rounded-lg">
                        <p className="text-white">{projectDesc}</p>
                        <div className="technologies d-flex text-white flex-wrap justify-content-center py-2">
                            {/* <small>{technology}</small> */}
                            <small className="mx-2">{t1}</small>
                            <small className="mx-2">{t2}</small>
                            <small className="mx-2">{t3}</small>
                            <small className="mx-2">{t4}</small>
                            <small className="mx-2">{t5}</small>
                            <small className="mx-2">{t6}</small>
                            <small className="mx-2">{t7}</small>
                        </div>
                    </div>
                    <div id="nav-links" className="py-2 d-flex flex-wrap justify-content-center">
                        <a href={clientCode} target="_blank" className="mx-3"><FontAwesomeIcon
                            icon={faGithub}
                            className="mr-2"
                        ></FontAwesomeIcon>Client code</a>
                        <a href={liveSite} target="_blank" className="mx-3">
                            <FontAwesomeIcon icon={faExternalLinkSquareAlt} className="mr-2" />Live</a>
                        <a href={serverCode} target="_blank" className="mx-3"><FontAwesomeIcon
                            icon={faGithub}
                            className="mr-2"
                        ></FontAwesomeIcon>Server code</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MainProject;